/**
---
title: CheckboxToggle
...

# CheckboxToggle


## Examples / Usage

basic:
`<CheckboxToggle className="my-optional-extra-class">My label Text <small>(optional sublabel)</small></CheckboxToggle>`

checked/on by default:
`<CheckboxToggle checked>My label Text</CheckboxToggle>`

**/

import PropTypes from 'prop-types';
import React, { Component, Children } from 'react';
import classnames from 'classnames';
import { getStyles, getStyleTag } from '../../styles/dynamicStyles';

export default class CheckboxToggle extends Component {
    render() {

        const { checked, className, handleClick, children } = this.props;

        const classNames = classnames('c-checkbox-toggle', className)
        return(
            <label className={classNames} style={getStyles('c-checkbox-toggle')}>
                {getStyleTag([
                    'c-checkbox-toggle__label',
                    'c-checkbox-toggle__indicator',
                    'c-checkbox-toggle__positions',
                    'c-checkbox-toggle__input',
                    'c-checkbox-toggle'
                ])}
                <input type="checkbox" onClick={handleClick} checked={checked} className="c-checkbox-toggle__input show-for-sr" />
                <span className="c-checkbox-toggle__bits">
                    <span className="c-checkbox-toggle__label" style={getStyles('c-checkbox-toggle__label')}>{children}</span>
                    <span className={classnames("c-checkbox-toggle__indicator", {'checked': checked})} style={getStyles('c-checkbox-toggle__indicator')} aria-hidden="true">
                        <span className="c-checkbox-toggle__positions" style={getStyles('c-checkbox-toggle__positions')} />
                    </span>
                </span>
            </label>
        )
    }
}

CheckboxToggle.propTypes = {
    checked: PropTypes.bool,
    handleClick: PropTypes.func
}

CheckboxToggle.defaultProps = { checked: false };



// WEBPACK FOOTER //
// ./webapp/components/elements/CheckboxToggle.js